import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import InputAdornment from '@mui/material/InputAdornment';
import SvgIcon from '@mui/material/SvgIcon';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import UserIcon from '@mui/icons-material/AccountCircle';
import React from 'react';

interface LoginFormProps {
  /** Function for handling form submit */
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  /**  CSS classes for this component */
  classes: {
    paper: string;
    form: string;
    submit: string;
    logo: string;
    inputRoot: string;
    focused: string;
    error: string;
  };
  logo: string;
  /** boolean, set true if previous login was failed and false if login is ok. Only use to indicate invalid login (not authentication per se) */
  errorMessage?: string;
}

const LoginForm = ({ handleSubmit, classes, logo, errorMessage = '' }: LoginFormProps) => {
  return (
    <Container component="main" maxWidth="xs" data-testid="loginform-main">
      <div className={classes.paper}>
        <img className={classes.logo} alt="logo" src={logo} />
        <Typography color="primary" component="h1" variant="h6" data-testid="login-prompt">
          Log in to Your Account
        </Typography>
        <form className={classes.form} noValidate onSubmit={handleSubmit} data-testid="form">
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            name="email"
            autoComplete="email"
            autoFocus
            placeholder="Username"
            data-testid="email"
            InputProps={{
              classes: {
                root: classes.inputRoot,
                focused: classes.focused,
                error: classes.error
              },
              startAdornment: (
                <InputAdornment position="start">
                  <UserIcon />
                </InputAdornment>
              )
            }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            error={errorMessage !== ''}
            name="password"
            placeholder="Password"
            type="password"
            id="password"
            data-testid="password"
            autoComplete="current-password"
            InputProps={{
              classes: {
                root: classes.inputRoot,
                focused: classes.focused,
                error: classes.error
              },
              startAdornment: (
                <InputAdornment position="start">
                  <SvgIcon viewBox="0 0 960 960">
                    <path d="M384 886.4v-419.2c-32-9.6-60.8-32-92.8-60.8-92.8-92.8-92.8-243.2 0-336s246.4-92.8 339.2 0 92.8 243.2 0 336c-22.4 22.4-54.4 41.6-86.4 54.4v128l41.6 41.6-41.6 41.6 41.6 41.6-41.6 41.6v6.4l44.8 38.4-41.6 41.6-3.2 38.4-83.2 80-76.8-73.6zM502.4 96c-25.6-25.6-64-25.6-89.6 0s-25.6 64 0 89.6c25.6 25.6 64 25.6 89.6 0s22.4-64 0-89.6z" />
                  </SvgIcon>
                </InputAdornment>
              )
            }}
            helperText={
              <Typography component="span" variant="subtitle2" data-testid="error-message">
                {errorMessage}
              </Typography>
            }
            FormHelperTextProps={{
              error: true
            }}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            data-testid="sign-in"
            className={classes.submit}
          >
            Sign In
          </Button>
        </form>
      </div>
    </Container>
  );
};

export default LoginForm;
